import forge from 'node-forge'
import { rsaPublicKeyPem } from 'src/config'

const encryptWithPubkey = (str: string): string => {
  const pubKey = forge.pki.publicKeyFromPem(forge.util.decode64(rsaPublicKeyPem))
  const encrypted = pubKey.encrypt(str, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
  })
  return forge.util.encode64(encrypted)
}

export {encryptWithPubkey}